import useServiceAccounts from './useServiceAccounts';
import { UseQueryResult } from 'react-query';
import {
  ServiceAccount,
  ServiceAccountAPIKey
} from '@/features/account-settings/types';

const useServiceAccountApiKeys = (
  organizationId: string,
  serviceAccountName: string
): UseQueryResult<ServiceAccountAPIKey[]> => {
  return useServiceAccounts(organizationId, {
    select: (serviceAccounts: ServiceAccount[]) => {
      return (
        serviceAccounts.find(account => account.name === serviceAccountName)
          ?.apiKeys ?? []
      );
    }
  });
};

export default useServiceAccountApiKeys;
